export default __webpack_public_path__ + "e1b629dc57ed7fc0dad62f0ce87a4399.png";